import {
  EntityManager,
  IEntityManagerConfiguration,
} from '@dch/entity-manager';
import { entityManagerConfiguration } from '@dch/ng-common';
import { MyBillConfig } from '../../config/my-bill.config';

export function configureEntityManager() {
  const myBillEntityManagerConfig: IEntityManagerConfiguration = {
    ...entityManagerConfiguration,
    ...MyBillConfig,
  };
  EntityManager.configure(myBillEntityManagerConfig);
  return () => {
    // nothing to do
  };
}
